export default __webpack_public_path__ + "static/portrait-of-young-businesspeople-working-a53f4e47d6ad81049a682917d03d947f.png";